<template>
  <div class="mx-1">
    <el-dialog
      v-if="showDialog"
      width="800px"
      top="40px"
      :visible.sync="showDialog"
      title="Thêm thành viên"
      destroy-on-close>
      <AddMember
        :conversation="conversation"
        :members="members" />
    </el-dialog>
    <el-dialog
      width="360px"
      v-if="showInfoPopup"
      :visible.sync="showInfoPopup"
      destroy-on-close>
      <ProfileInfoPopup :conversation="{ toId: selectItem.id, accountId: this.conversation.accountId }" />
    </el-dialog>

    <div class="my-2 d-flex">
      <div class="font-size-15 fw-semibold">Danh sách thành viên</div>
      <div class="mx-1 flex-1 font-size-15 fw-bold">({{ getCount() }})</div>

      <el-image
        v-if="members.length > 0"
        class="mx-2 pointer pt-1"
        @click="showDialog = true"
        src="/assets/icon/add_group.svg" />
    </div>
    <el-input
      v-model="searchKey"
      size="small"
      @input="search()"></el-input>
    <div
      class="my-3 overflow-auto"
      style="max-height: calc(100vh - 170px)">
      <div
        :key="index"
        v-for="(item, index) in results">
        <div class="my-1 d-flex align-items-center">
          <el-avatar
            class="mx-1"
            :size="30"
            :src="item.avatar" />
          <div class="mx-1 flex-1 fw-semibold">{{ item.name }}</div>
          <el-tooltip
            class="item pointer mx-1"
            effect="dark"
            :content="item.accountId !== item.id ? 'Xóa thành viên' : 'Rời nhóm'"
            v-if="!item.page && !item.group && deletedCk"
            placement="top">
            <div @click="deleteMember(item)">
              <i class="el-icon-delete font-size-20 text-danger fw-bold"></i>
            </div>
          </el-tooltip>
          <el-tooltip
            class="item pointer mx-1"
            effect="dark"
            content="Thông tin"
            v-if="!item.page && !item.group"
            placement="top">
            <div @click="showInfo(item)">
              <i class="el-icon-user font-size-20 text-secondary fw-bold"></i>
            </div>
          </el-tooltip>
        </div>
        <div class="divider-custom" />
      </div>
    </div>
  </div>
</template>

<script>
import AddMember from "../AddMember";
import ProfileInfoPopup from "../ProfileInfoPopup";

export default {
  name: "MemberTab",
  components: { ProfileInfoPopup, AddMember },
  props: {
    conversation: {
      type: Object,
    },
  },
  watch: {
    conversation: function () {
      this.getGroupInfo();
    },
  },
  data() {
    return {
      contactList: [],
      searchKey: "",
      members: [],
      showDialog: false,
      items: [],
      results: [],
      memberMap: [],
      showInfoPopup: false,
      selectItem: {},
      deletedCk: false,
    };
  },
  methods: {
    showInfo(item) {
      this.selectItem = item;
      this.showInfoPopup = true;
    },
    deleteMember(item) {
      this.$confirm("Bạn chắc chắn muốn xóa?", "Cảnh báo", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/conversation/removeGroupMember", {
              params: {
                accountId: this.conversation.accountId,
                memberId: item.id,
                groupId: this.conversation.toId,
                name: item.name,
              },
            })
            .then(() => {
              this.alert("success", "Đã xóa " + item.name + " ra khỏi nhóm!");
              this.getGroupInfo();
            });
        })
        .catch(() => {});
    },
    addFriend(item) {
      this.$http
        .get("/api/contact/addFriend", {
          params: {
            userId: item.id,
            accountId: this.conversation.accountId,
          },
        })
        .then(() => {
          this.alert("success", "Gửi lời mời kết bạn tới " + item.name + " thành công.");
        });
    },
    isFriend(item) {
      return this.contactList.some((s) => s.id === item.id) || item.id === this.conversation.accountId;
    },
    closeDialog() {
      this.showDialog = false;
    },

    search() {
      if (this.searchKey.length > 0) {
        this.results = this.members.filter((p) => p.name.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.results = this.members;
      }
    },
    getGroupInfo() {
      this.$http
        .get("/api/message/groupInfoV2", {
          params: {
            accountId: this.conversation.accountId,
            groupId: this.conversation.toId,
          },
        })
        .then((resp) => {
          this.deletedCk = false;
          this.memberMap = [];
          let gridInfoMap = resp.data.data?.gridInfoMap[this.conversation.toId];

          gridInfoMap.memberVerMap = {};
          gridInfoMap.memVerList.forEach((i) => {
            let parts = i.split("_");
            gridInfoMap.memberVerMap[parts[0]] = parts[1];
          });

          let data;
          if (gridInfoMap !== undefined) {
            data = gridInfoMap.memberVerMap;
            if (this.conversation.accountId === gridInfoMap.creatorId) {
              this.deletedCk = true;
            }
            gridInfoMap.adminIds.forEach((id) => {
              {
                if (this.conversation.accountId === id) this.deletedCk = true;
              }
            });
          }
          if (resp.data.data?.removedsGroup.length > 0) this.alert("error", "Bạn đã rời khỏi nhóm này");
          for (let mem in data) {
            this.memberMap.push({ name: mem, val: data[mem] });
          }
          this.getGroupMembers();
        });
    },
    getGroupMembers() {
      this.members = [];
      let row = 0;
      let limit = 400;
      let count = this.memberMap.length;
      row = (count - (count % limit)) / limit + 1;

      for (let i = 0; i < row; i++) {
        let mem = this.memberMap.slice(i * limit, (i + 1) * limit);
        let grMem = {};
        mem.forEach((item) => {
          grMem[item.name] = item.val;
        });
        let request = {
          memberMap: grMem,
          accountId: this.conversation.accountId,
        };

        this.$http.post("/api/conversation/groupMember", request).then((resp) => {
          this.members.push(...resp.data);
          this.search();
        });
      }
    },
    getCount() {
      return this.members.length;
    },
    getContacts() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.conversation.accountId,
            page: 0,
            pageSize: 10000,
          },
        })
        .then((resp) => {
          this.contactList = resp.data.content;
        });
    },
  },
  mounted() {
    this.$bus.$on("closeDialogMember", () => {
      this.showDialog = false;
      this.members = [];
      this.getGroupInfo();
    });
  },
  created() {
    this.getGroupInfo();
    this.getContacts();
  },
  beforeDestroy() {
    this.$bus.$off("closeDialogMember");
  },
};
</script>

<style scoped></style>
